import { render } from "./ClassificationScoreChart.vue?vue&type=template&id=44f6cf8b&scoped=true"
import script from "./ClassificationScoreChart.vue?vue&type=script&lang=js"
export * from "./ClassificationScoreChart.vue?vue&type=script&lang=js"

import "./ClassificationScoreChart.vue?vue&type=style&index=0&id=44f6cf8b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f6cf8b"]])

export default __exports__